import { COUNTRY_SHORTCODES } from '../../../constants'

export const US_REGEX = /\d*/
export const JP_REGEX = /[\d０１２３４５６７８９]*/

export enum JP_NUMBERS {
  '０',
  '１',
  '２',
  '３',
  '４',
  '５',
  '６',
  '７',
  '８',
  '９',
}

export const LOCALE_REGEX = {
  [COUNTRY_SHORTCODES.US]: US_REGEX,
  [COUNTRY_SHORTCODES.JP]: JP_REGEX,
}

export const LOCALE_NUMBERS = {
  [COUNTRY_SHORTCODES.JP]: JP_NUMBERS,
}
